<template>
  <div>
    <v-tabs
      v-model="tab"
      color="grey lighten-3"
      active-class="grey"
      background-color="grey lighten-3"
      hide-slider
    >
      <v-tab>Veículo</v-tab>
      <v-tab>Motorista</v-tab>
      <v-tab>Lotação</v-tab>
      <v-tab>Rotas</v-tab>
      <v-tab>Documento</v-tab>
      <v-tab>Fotos</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <VeiculoForm />
      </v-tab-item>
      <v-tab-item>
        <TabMotorista />
      </v-tab-item>
      <v-tab-item>
        <TabLotacao />
      </v-tab-item>
      <v-tab-item>
        <TabRota />
      </v-tab-item>
      <v-tab-item>
        <TabDocumento />
      </v-tab-item>
      <v-tab-item>
        <TabFoto />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
// import { mapState } from 'vuex';
import VeiculoForm from '@/views/private/frota/veiculo/Form.vue';
import TabMotorista from '@/views/private/frota/veiculo/tabs/TabMotorista.vue';
import TabLotacao from '@/views/private/frota/veiculo/tabs/TabLotacao.vue';
import TabDocumento from '@/views/private/frota/veiculo/tabs/TabDocumento.vue';
import TabRota from '@/views/private/frota/veiculo/tabs/TabRota.vue';
import TabFoto from '@/views/private/frota/veiculo/tabs/TabFotos.vue';

export default {
  name: 'VeiculoTabs',
  components: { TabFoto, TabRota, TabDocumento, TabLotacao, TabMotorista, VeiculoForm },
  data: () => ({
    tab: null,
  }),
  computed: {
    // ...mapState('lancamento', ['loading']),
  },
  methods: {},
  watch: {},
};
</script>
